import Result from "@/core/common/Result";
import {
  IPodeVisualizarPesquisaCSATUseCase,
  PodeVisualizarPesquisaCSATInput,
  PodeVisualizarPesquisaOutput
} from "../ports/PodeVisualizarPesquisaCSATUseCase";
import { inject, injectable } from "inversify";
import {
  type IPesquisaCSATAtivaGateway,
  pesquisaCSATAtivaGatewayDI
} from "../ports/PesquisaCSATAtivaGateway";
import "reflect-metadata";

@injectable()
export class PodeVisualizarPesquisaCSATUseCaseAdapter
  implements IPodeVisualizarPesquisaCSATUseCase
{
  @inject(pesquisaCSATAtivaGatewayDI)
  private readonly pesquisaCSATAtivaGateway!: IPesquisaCSATAtivaGateway;

  async podeVisualizar(
    params: PodeVisualizarPesquisaCSATInput
  ): Promise<Result<PodeVisualizarPesquisaOutput>> {
    const response = await this.pesquisaCSATAtivaGateway.pesquisaAtiva({
      pagina: params.pesquisa
    });

    if (response.isFailure) return Result.fail(response.error);

    if (!response.getValue().ativa) {
      return Result.ok({
        id: response.getValue().pesquisaCSATId,
        podeVisualizar: false
      });
    }

    if (response.getValue().primeiroAcesso)
      return Result.ok({
        id: response.getValue().pesquisaCSATId,
        podeVisualizar: false
      });

    const pesquisaAtivaENaoIgnorada =
      response.getValue().ativa && !response.getValue().ignorada;

    const podeVisualizar =
      pesquisaAtivaENaoIgnorada && !response.getValue().respondida;

    return Result.ok({
      id: response.getValue().pesquisaCSATId,
      podeVisualizar
    });
  }
}
